exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pg-sales-tax-table tbody tr td {\n  font-size: 13px;\n  font-weight: normal;\n}\n", ""]);

// exports
